// Desktop: restiamo sull'app React (home a 3 colonne, risultati a griglia).
// Il vecchio redirect a /home-desktop.html (QR) è disabilitato.

const DesktopRedirect = () => null;

export default DesktopRedirect;
